import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.webp"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="conocimientos">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Conocimientos</h2>
                        <p>Actualmente esto son alguno de los campos con los quer mejor trabajo<br></br> Siempre ampliando conocimientos ya se en React Native, VmWare,Git...</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src={meter1} alt="Front" />
                                <h5>Front-end Dev</h5>
                            </div>
                            <div className="item">
                                <img src={meter2} alt="Database" />
                                <h5>Database</h5>
                            </div>
                            <div className="item">
                                <img src={meter3} alt="Mobile" />
                                <h5>Mobile App Dev</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="Versioning" />
                                <h5>Versioning</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="LINUX" />
                                <h5>LINUX (Ubuntu Server)</h5>
                            </div>
                            <div className="item">
                                <img src={meter1} alt="WINDOWS" />
                                <h5>WINDOWS Server</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <picture>
                    <source className="background-image-left" type="image/webp" srcSet={colorSharp} alt="Fondo_Conocimentos"/>
                    <source className="background-image-left" type="image/jpeg" srcSet={colorSharp} alt="Imagen_{imgUrl}"/>
                    <img className="background-image-left" srcSet={colorSharp} alt="Imagen_{imgUrl}"/>
                    </picture>
    </section>
  )
}
